import decode from 'lean-he/decode'

/**
 * Decodes any named and numerical character references in the text
 * @param {String} value
 */
export function htmlDecode (value: any) {
  if (value === null || value === undefined || value === '') return ''
  if (typeof value !== 'string') return decode(String(value))
  return decode(value)
}
